<template>
    <ContentPage title="Política de Privacidade" sub-title="Nos termos do art. 13 do Regulamento (UE) 2016/679">
        <p>
            Adorea S.r.l. (Fleequid), com sede em Via provinciale per Bizzarone, 43 – 22077 Olgiate Comasco (CO), NIF e CF 04114790134, inscrita no
            Registo Comercial de Como sob o número 04114790134, capital social 10.000,00€ i.v. („
            <strong>Adorea S.r.l. (Fleequid)</strong>") na qualidade de responsável pelo tratamento, fornece-lhe a presente informação sobre o
            tratamento dos seus dados pessoais nos termos do Art. 13 do Regulamento (UE) n. 2016/679 („<strong>RGPD</strong>").
        </p>

        <BaseVerticalStack as="ol" class="list-inside list-decimal">
            <li>
                <h3 class="text-highlighted inline-block font-bold">Finalidade do tratamento e base jurídica</h3>
                <p class="my-4">
                    Adorea S.r.l. (Fleequid) é uma empresa que se dedica à gestão de leilões online relativos a veículos industriais, destinados a uma
                    clientela empresarial. Quando uma empresa se regista na Adorea S.r.l. (Fleequid) para participar num leilão, ser-lhe-á solicitado
                    que indique alguns dados do respetivo referente, nomeadamente nome, apelido, e-mail e número de telefone
                    („<strong>Dados</strong>"). Esses dados serão tratados pela Adorea S.r.l. (Fleequid), também através de ferramentas
                    eletrónicas/digitais, exclusivamente para as seguintes finalidades e bases jurídicas:
                </p>
                <div class="my-4 grid grid-cols-[40px_1fr_1fr] grid-rows-[24px_1fr_1fr] gap-2">
                    <div class="font-bold">N.º</div>
                    <div class="font-bold">Finalidade</div>
                    <div class="font-bold">Base jurídica</div>
                    <div class="font-bold">1.1</div>
                    <div>
                        Permitir a participação no leilão conforme solicitado pelo utilizador, garantindo o seu normal funcionamento e a possibilidade
                        de contactar o referente da empresa em caso de adjudicação
                    </div>
                    <div>Execução do contrato</div>
                    <div class="font-bold">1.2</div>
                    <div>Envio de material informativo relativo aos serviços da Adorea S.r.l. (Fleequid)</div>
                    <div>
                        Interesse legítimo, com base no art. 130, n.º 4, do d.lgs. 196/2003. O interessado poderá opor-se em qualquer momento ao
                        tratamento, de forma simples e gratuita.
                    </div>
                </div>
                <p class="my-4">
                    Fornecer os Dados Pessoais é essencial para participar no leilão e usufruir dos serviços da Adorea S.r.l. (Fleequid), e a falta de
                    fornecimento prejudicaria, portanto, essa participação e a respetiva constituição da relação contratual com a Adorea S.r.l.
                    (Fleequid).
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Comunicação e transferência dos Dados</h3>
                <p class="my-4">
                    Os Dados poderão também ser tratados pelas empresas subcontratadas que exercem atividades conexas, instrumentais ou de apoio às da
                    Adorea S.r.l. (Fleequid) e às quais a Adorea S.r.l. (Fleequid) pode recorrer para executar as finalidades acima indicadas. Estas
                    agirão como subcontratantes, segundo as instruções da Adorea S.r.l. (Fleequid). Caso, na partilha de informações, os Dados sejam
                    transferidos para países fora do Espaço Económico Europeu, a Adorea S.r.l. (Fleequid) assegurará que os Dados sejam transferidos
                    em conformidade com a presente política de privacidade e conforme previsto pela regulamentação aplicável sobre proteção de dados.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Conservação dos Dados</h3>
                <p class="my-4">
                    Os seus Dados serão conservados pelo tempo estritamente necessário para cumprir as finalidades referidas no ponto 1 acima, ou
                    seja, 10 anos a partir da cessação dos efeitos do contrato. Este período de conservação justifica-se, quanto às finalidades de
                    marketing, pela natureza particular dos bens objeto dos leilões geridos pela Adorea S.r.l. (Fleequid), nomeadamente veículos
                    industriais de elevado valor. Decorrido esse período, os Dados serão eliminados ou anonimizados.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Direitos do titular dos dados</h3>
                <p class="my-4">
                    Poderá exercer em qualquer momento o direito de acesso aos seus próprios Dados e às seguintes informações: finalidade do
                    tratamento; categorias de dados pessoais em causa; destinatários ou categorias de destinatários a quem os dados podem ser
                    comunicados; sempre que possível, o período de conservação dos dados, conforme previsto no art. 15 RGPD; o direito de retificação
                    dos dados pessoais inexatos nos termos do art. 16 RGPD; o direito de obter o apagamento dos dados que lhe dizem respeito, quando
                    se verifiquem as condições do art. 17 RGPD; o direito de solicitar a limitação do tratamento, quando se verifiquem as condições do
                    art. 18 RGPD; o direito à portabilidade dos dados quando se verifiquem as condições do art. 20 RGPD; o direito de se opor ao
                    tratamento, incluindo o tratamento para fins de marketing, quando se verifiquem as condições do art. 21 RGPD. Poderá ainda
                    apresentar sempre uma reclamação junto da Autoridade Garante para a Proteção de Dados Pessoais segundo as modalidades ilustradas
                    no site
                    <NuxtLink class="text-primary hover:underline" to="https://www.garanteprivacy.it" target="_blank" external>
                        www.garanteprivacy.it</NuxtLink
                    >.
                </p>
                <p class="my-4">
                    Para efetuar pedidos ou questões sobre as nossas práticas em matéria de privacidade, convidamo-lo a contactar-nos através do
                    endereço <FleequidEmailLink type="privacy" />. Respondemos a todos os pedidos dos utilizadores que desejam exercer os seus
                    direitos em matéria de proteção de dados pessoais em conformidade com as leis vigentes sobre proteção de dados.
                </p>
            </li>
        </BaseVerticalStack>
    </ContentPage>
</template>
